import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';
import type { MonthlyData } from '../hooks/useAnalyticsData';

interface Props {
  data: MonthlyData[];
  loading: boolean;
}

function CustomTooltip({ active, payload, label }: { active?: boolean; payload?: { value: number; name: string }[]; label?: string }) {
  if (!active || !payload?.length) return null;
  const total = payload.reduce((s, p) => s + p.value, 0);
  const completed = payload.find(p => p.name === '已完成')?.value ?? 0;
  const rate = total > 0 ? Math.round((completed / total) * 100) : 0;
  return (
    <div className="bg-white border border-gray-100 rounded-xl px-4 py-3 text-sm">
      <p className="font-semibold text-gray-700 mb-1.5">{label}</p>
      <p className="text-gray-600">总订单：<span className="font-medium text-gray-900">{total} 单</span></p>
      <p className="text-emerald-600">已完成：<span className="font-medium">{completed} 单</span></p>
      <p className="text-gray-400 text-xs mt-1">完成率 {rate}%</p>
    </div>
  );
}

export default function OrderVolumeChart({ data, loading }: Props) {
  return (
    <div className="bg-white border border-gray-100 rounded-xl p-5">
      <div className="mb-5">
        <h3 className="text-sm font-semibold text-gray-800">订单量趋势</h3>
        <p className="text-xs text-gray-400 mt-0.5">近12个月每月订单量</p>
      </div>
      {loading ? (
        <div className="h-48 flex items-center justify-center">
          <div className="text-sm text-gray-400 animate-pulse">加载中...</div>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={190}>
          <BarChart data={data} margin={{ top: 4, right: 4, left: 0, bottom: 0 }} barSize={18}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" vertical={false} />
            <XAxis dataKey="month" tick={{ fontSize: 11, fill: '#9ca3af' }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: '#9ca3af' }} axisLine={false} tickLine={false} width={28} />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: '#f9fafb' }} />
            <Bar dataKey="orders" name="全部" radius={[4, 4, 0, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.orders > 0 ? '#0d9488' : '#e5e7eb'} fillOpacity={0.85} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
